import React from "react";
import { useState, useEffect } from "react";
import "./About.css";
import Menu from "../menu/Menu";

export default function About() {
  useEffect(() => {
    document.title = "splash overflow | About";
  }, []);

  const [user, setUser] = useState(null);
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    fetch(`${API_URL}/api/me`, { credentials: "include" })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => data && setUser(data));
  }, []);

  return (
    <div>
      <Menu user={user} setUser={setUser} />
      <div className="aboutComponent">
        <br></br>
        <div className="aboutTitle">
          <span style={{ fontWeight: "800", fontSize: "2em" }}>
            Willkommen auf splash overflow!
          </span>
        </div>
        <br></br>
        <div className="aboutIntro">
          <span>
            Diese Webanwendung ist im Rahmen meines Semesterprojekts entstanden
            und wurde mit dem Ziel entwickelt, eine spezialisierte Plattform für
            strukturiertes Design-Feedback bereitzustellen.<br></br>
            Sie richtet sich insbesondere an Kreative, Gestalter:innen und
            Entwickler:innen, die ihre Entwürfe nicht nur präsentieren, sondern
            gezielt kommentieren und weiterentwickeln möchten.<br></br>
            <br></br>
            Aktuell befindet sich die Anwendung in einer aktiven Testphase.
            Dabei liegt der Fokus auf der Optimierung der Benutzerfreundlichkeit
            sowie der Erweiterung der Funktionalitäten, stets mit dem Anspruch,
            den Feedbackprozess so effizient und intuitiv wie möglich zu
            gestalten.<br></br>
            <br></br>
            Im weiteren Verlauf dieser Seite werden alle zentralen Funktionen
            detailliert vorgestellt, sodass du dir ein genaues Bild von der
            Arbeitsweise und dem Potenzial der Plattform machen kannst.
          </span>
        </div>
        <br></br>
        <br></br>
        <br></br>
        <div className="flex items-center justify-center">
          <img
            src="/semesterprojekt/img/about.png"
            style={{ width: "95%" }}
          ></img>
        </div>
      </div>
    </div>
  );
}
